import { TBundleQcStore } from '@monorepo/types';
import produce from 'immer';
import { INITIAL_CACHE_RESET_TIMESTAMP } from '../metadata/metadata.reducer';
import { BundleQcDBActionTypes, TBundleQcActions } from './bundle-qc.actions';

export const DEFAULT_LINE_SHIFT_INCOMPLETE_BUNDLE_SYNC_INFO = {
  lastSyncedAt: INITIAL_CACHE_RESET_TIMESTAMP,
};
export function getBundleQcInitialState() {
  const bundleQcInitialState: TBundleQcStore = {
    bundleQcBgDB: {},
    bundleQcBgDBLockDetails: {
      isLocked: false,
      lockedBy: 'NONE',
    },
  };
  return bundleQcInitialState;
}
export const bundleQcInitialState: TBundleQcStore = getBundleQcInitialState();

export function BundleQcDBStateReducer(
  state: TBundleQcStore = bundleQcInitialState,
  action: TBundleQcActions,
): TBundleQcStore {
  switch (action.type) {
    case BundleQcDBActionTypes.ReleaseBundleQcBgDBLock: {
      return produce(state, (draft) => {
        draft.bundleQcBgDBLockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    case BundleQcDBActionTypes.UpdateBundleQcBgDBLockDetails: {
      return produce(state, (draft) => {
        draft.bundleQcBgDBLockDetails = action.lockDetails;
      });
    }
    case BundleQcDBActionTypes.UpdateBundleQcBgDBAndReleaseLock: {
      return produce(state, (draft) => {
        draft.bundleQcBgDB = action.bundleQcBgDB;
        draft.bundleQcBgDBLockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    default:
      return state;
  }
}
